import instance from './instance';

export const proposal = async (values) => {
  try {
    const response = await instance.post('/v1/slack/proposal', values);
    return response.data;
  } catch (error) {
    console.error('Error fetching daily PnL data:', error);
    throw error;
  }
};
